/**
 * File: /Users/tomasmuniesa/Documents/develop/nousmedis/nm-apps/3_catalog_cloud/develop/frontend/src/app/modules/catalog-cloud/components/product/product-grid-item/product-grid-item.component.ts
 * Project: /Users/tomasmuniesa/Documents/develop/nousmedis/nm-apps/3_catalog_cloud/develop/frontend
 * Created Date: Monday, April 7th 2025, 9:53:42 am
 * Author: Tomás
 * -----
 * Last Modified:  Monday, 7th April 2025 9:55:57 am
 * Modified By: Tomás (tomas@cege.es>)
 * -----
 * Copyright (c) 2025 Nousmedis, CeGe
 * ------------------------------------
 */


/*
 * File: product-grid-item.component.ts                                        *
 * Project: catalog-cloud                                                      *
 * File Created: Thursday, 17th February 2022 11:48:25                         *
 * Author: Tomás Muniesa (tomas@cege.es)                                       *
 * -----                                                                       *
 * Last Modified: Thursday, 2nd March 2023 14:40:19                            *
 * Modified By: Tomás Muniesa (tomas@cege.es>)                                 *
 * -----                                                                       *
 * Copyright 2021 - 2022 Nousmedis, CeGe                                       *
 */



import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observer, Subscription } from 'rxjs';
import { Product } from '@nousmedis/cc-types';
import { ProductService } from '../../../services/product.service';
import { TooltipOptions } from 'primeng/api';
@Component({
  selector: 'app-product-grid-item',
  templateUrl: './product-grid-item.component.html',
  styleUrls: ['./product-grid-item.component.scss']
})
export class ProductGridItemComponent implements OnInit, OnDestroy {

  @Input() item: Product;

  selected: boolean = false;
  showDetails: boolean = false;

  imSelected: Subscription = new Subscription();
  showTooltip$: Subscription = new Subscription();

  elevation: string = '';

  showTooltip: boolean = false;
  tooltipOptions: TooltipOptions = {
    tooltipPosition: 'left',
    showDelay: 100,
    hideDelay: 100,
    tooltipZIndex: 'z-index: 1000'

  };
  constructor (private productService: ProductService) { }
  ngOnDestroy(): void {
    this.imSelected.unsubscribe();
    this.showTooltip$.unsubscribe();

  }

  ngOnInit(): void {
    this.productService.isShowProductDetails().subscribe((show: boolean) => {
      this.showTooltip = show;
    });
  
    this.imSelected = this.productService.viewDetails.subscribe((data: Product) => {
      if (data.id != this.item.id) this.selected = false;
      else this.selected = true;
    });
  
    this.showTooltip$ = this.productService.showProductDetailsWindow$.subscribe(
      (show: boolean) => {
        this.showTooltip = show;
      }
    );
  }

  sendProductToDetailView() {
    this.productService.productDetails$.next(this.item);
  }

  setDetails(e: any) {
    let details = document.getElementById('product-details-' + this.item.id);

    if (!this.showDetails) {
      details.style.left = e.x - 200 + 'px';
      details.style.top = e.y - 30 + 'px';
      details.style.display = 'block';
      details.classList.remove('item-details-hide');

    }
    else {
      details.classList.add('item-details-hide');
    }
  }

  test(e: any) {

  }


  select(item: any) {
    this.productService.selectedProduct(item);
  }

  addElevation() {
    this.elevation = '';
  }

  removeElevation() {
    this.elevation = '';

  }

  dragItem(event: DragEvent) {
    console.log("!Ondrag funciona");

    const dragPreview = event.target as HTMLElement;

    //añadir la funcion para editar el preview del drag
    this.setPreviewStyle(event, dragPreview);

    this.productService.dragProduct({ idCell: null, item: this.item, idPage: null });
  }
  dragEnd(event: DragEvent) {
    console.log("!OnDragEnd funciona");
    const element = event.target as HTMLElement;
    element.classList.remove('dragging');
  }

  setPreviewStyle(event: DragEvent, dragPreview: HTMLElement) {
    this.productService.setPreviewStyle(event, dragPreview, this.item);
  }
}
